<template>
    <div class="opt_g2">
        <div id="optStars" :class="{opt_open: this.openedLayer === 'starJoin'}" @click.stop="openLayer">
            <div class="opt_selected">
                <span class="tf_opt">
                    <span class="txt_selected">스타가 가입한 팬카페</span>
                    <span class="ico_cafetop ico_arrow">옵션 더 보기</span>
                </span>
            </div>
        </div>
        <div id="optStars_layer" class="opt_layer" v-show="openedLayer === 'starJoin'" @click.stop>
            <div class="search_stars">
                <input type="text" id="searchStar" class="tf_stars" placeholder="스타명을 검색해보세요" autocomplete="off" maxlength="15" @keydown="searchStar" v-model="starSearchQuery" ref="search">
                <button class="btn_search ico_cafetop" id="searchStarBtn" @click="searchStar">검색</button>
            </div>
            <ul class="tab_stars">
                <li id="starJoinCafeCate_all" :class="{ on: category === 'all' }" @click="setCategory"><span class="link_tab">전체</span></li>
                <li id="starJoinCafeCate_musician" :class="{ on: category === 'musician' }" @click="setCategory"><span class="link_tab">가수</span></li>
                <li id="starJoinCafeCate_actor" :class="{ on: category === 'actor' }" @click="setCategory"><span class="link_tab">배우</span></li>
                <li id="starJoinCafeCate_sportsman" :class="{ on: category === 'sportsman' }" @click="setCategory"><span class="link_tab">스포츠</span></li>
                <li id="starJoinCafeCate_entertainer" :class="{ on: category === 'entertainer' }" @click="setCategory"><span class="link_tab">방송인</span></li>
                <li id="starJoinCafeCate_etc" :class="{ on: category === 'etc' }" @click="setCategory"><span class="link_tab">기타</span></li>
            </ul>
            <div class="box_stars" id="starJoinCafeList" @scroll="loadMoreStarJoin" ref="starJoinList">
                <ul class="list_stars">
                    <star-join-item v-for="(fancafe, index) in fancafeList" v-bind="fancafe" :key="'star-join-' + index"></star-join-item>
                    <li v-if="fancafeList.length === 0">
                        <div class="group_noresult">
                            <div class="ico_cafetop ico_result">검색결과</div>
                            <em>{{ resultText }}</em>에 대한 <br>
                            검색 결과가 없습니다.
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import StarJoinItem from './StarJoinItem.vue';
import { mapState } from 'vuex';
import $ from "jquery";

export default {
    components: {
        StarJoinItem
    },
    data() {
        return {
            fancafeList: [],
            starSearchQuery: "",
            resultText: "",

            category: "all",
            currentPage: 1,

            more: false
        }
    },
    computed: {
        ...mapState(["openedLayer"]),
    },
    methods: {
        getStarJoin() {
            this.resultText = this.starSearchQuery;
            this.$nextTick(() => {
                this.$refs.starJoinList.scrollTop = 0;
            });

            const url = `/_c21_/api/fancafe/starjoin/${this.category}`;
            $.ajax({
                url,
                data: {
                    page: this.currentPage,
                    query: this.starSearchQuery
                }
            }).then(function (res) {
                this.fancafeList = res.fancafeList;
                this.more = res.more;
            }.bind(this));
        },
        setCategory(e) {
            const newCategory = e.currentTarget.id.replace("starJoinCafeCate_", "");
            if(["all", "musician", "actor", "sportsman", "entertainer", "etc"].indexOf(newCategory) === -1) return;
            this.starSearchQuery = "";
            this.category = newCategory;
            this.currentPage = 1;
            
            this.getStarJoin();
        },
        searchStar(e) {
            if (e.keyCode === 13 || e.target.id === "searchStarBtn") {
                if (this.starSearchQuery === "") {
                    alert("검색어를 입력해 주세요");
                    return false;
                }
                this.category = "all";
                this.getStarJoin();
            }
        },
        loadMoreStarJoin({ target }) {
            if (this.more && target.scrollTop === (target.scrollHeight - target.offsetHeight)) {
                const url = `/_c21_/api/fancafe/starjoin/${this.category}`;
                $.ajax({
                    url,
                    data: {
                        page: ++this.currentPage,
                        query: this.starSearchQuery
                    }
                }).then(function (res) {
                    this.fancafeList = [...this.fancafeList, ...res.fancafeList];
                    this.more = res.more;
                }.bind(this));
            }
        },
        openLayer() {
            this.$store.commit("setOpenedLayer", "starJoin");
        },
    },
    watch: {
        "openedLayer": function() {
            if(this.openedLayer === "starJoin") {
                this.starSearchQuery = "";
                this.category = "all";
                this.currentPage = 1;
                this.getStarJoin();

                setTimeout(() => { this.$refs.search.focus() }, 0);
            }
        }
    }
}
</script>
